module.exports = __webpack_public_path__ + "img/npc.25f95c8e.png";